import { Component, ReactNode } from 'react'

import Popup from 'components/features/pfm/Popup/Popup'
import { RewardStatus } from 'interfaces/bounty'
import { RewardsStatusInColor } from 'components/features/pfm/RewardDetails/RewardStatusInColor/RewardStatusInColor'
import { RewardsStatusLabel } from 'components/features/pfm/RewardDetails/RewardsStatusLabel/RewardsStatusLabel'

import * as styles from 'components/features/pfm/RewardDetails/ModalStatusDescription.css'

type ModalStatusDescriptionProps = {
  statuses: Partial<Record<RewardStatus, string>>
  title: ReactNode
  onCloseClick: () => void
}

const STATUSES_WITH_LINE: RewardStatus[] = [
  'pending',
  'confirmed',
  'cryptoPending',
]

const STATUSES_ICON_IN_COLOR: RewardStatus[] = [
  'pending',
  'confirmed',
  'earned',
  'cryptoPending',
  'cryptoConfirmed',
]

const STATUSES_ICON_AS_EMPTY_CIRCLE: RewardStatus[] = [
  'expired',
  'cryptoCancelled',
]

export class ModalStatusDescription extends Component<ModalStatusDescriptionProps> {
  render () {
    const { onCloseClick } = this.props

    return (
      <Popup
        title={ this.renderTitle() }
        withBottomCloseButton
        onCloseButtonClick={ onCloseClick }
      >
        { this.renderContent() }
      </Popup>
    )
  }

  renderContent () {
    const { statuses } = this.props
    return (
      <div className={ styles.content }>
        {
          Object.keys(statuses).map(
            (key: RewardStatus) => this.renderStep(key, String(statuses[key]))
          )
        }
      </div>
    )
  }

  renderLeftLineForStatus (status: RewardStatus): ReactNode {
    return STATUSES_WITH_LINE.includes(status) && (
      <div className={ styles.line } />
    )
  }

  renderIcon (status: RewardStatus): ReactNode {
    return (
      <RewardsStatusInColor
        status={ status }
        className={ styles.statusIcon }
        asEmptyCircle={ STATUSES_ICON_AS_EMPTY_CIRCLE.includes(status) }
        withBackgroundColor={ STATUSES_ICON_IN_COLOR.includes(status) }
      />
    )
  }

  renderStep (status: RewardStatus, description: string) {
    return (
      <div key={ status } className={ styles.step }>
        { this.renderIcon(status) }
        { this.renderLeftLineForStatus(status) }
        <div className={ styles.stepName }>
          <RewardsStatusLabel status={ status } />
        </div>
        <div className={ styles.stepDescription }>
          { description }
        </div>
      </div>
    )
  }

  renderTitle () {
    return this.props.title
  }
}
